module.exports = __webpack_public_path__ + "img/normal-xue2.8a64955a.png";